import classNames from 'classnames';
import { ComponentProps } from 'react';
import { QuoteDetails } from 'routes/essential-workspace/components/quote-panel/quote/details';
import { QuoteModes } from 'routes/essential-workspace/components/quote-panel/quote/modes';
import { QuoteActions } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions';
import { QuoteSummary } from 'routes/essential-workspace/components/quote-panel/quote/summary';
import { QuoteStatus } from 'routes/essential-workspace/components/quote-status';

import './style.scss';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';

type Props = { isBordered?: boolean; isShadowed?: boolean; isBlurred?: boolean } & ComponentProps<'div'>;

function QuoteContainer({ isBordered = false, isShadowed = false, isBlurred = false, className, ...props }: Props) {
  const { backgroundColor, borderColor, shadow } = useQuote();
  return (
    <div
      className={classNames(
        backgroundColor,
        isBordered && borderColor,
        isShadowed && shadow,
        isBlurred && 'bg-blur',
        className,
      )}
      {...props}
    />
  );
}

function QuoteHeader({ className, ...props }: ComponentProps<'div'>) {
  return <div className={classNames('flex-x align-items-start w-100 gap-2 p-4', className)} {...props} />;
}

function StatusBadge() {
  const { formId } = useQuote();
  return <QuoteStatus variant="badge" formId={formId} />;
}

export const Quote = Object.assign(QuoteContainer, {
  Header: QuoteHeader,
  Summary: QuoteSummary,
  Modes: QuoteModes,
  Badge: StatusBadge,
  Details: QuoteDetails,
  Actions: QuoteActions,
});
